module.exports = __webpack_public_path__ + "static/img/case2.5514236.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/case2.jpg
// module id = 4264
// module chunks = 1